import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { getM3Colors, getM3Elevation } from "../../theme/style/m3Palette";

const HeaderContainer = styled(Box)(({ theme }) => {
  const isDark = theme.palette.mode === "dark";
  const m3 = getM3Colors(isDark);
  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 78,
    // Translucent surface so page content blurs beneath the sticky header
    backgroundColor: alpha(isDark ? m3.surfaceContainerLow : m3.surfaceContainerLowest, 0.92),
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    borderBottom: `1px solid ${m3.outlineVariant}`,
    paddingLeft: theme.spacing(4),
    paddingRight: 0,
    position: "sticky",
    top: 0,
    zIndex: 1100,
    boxShadow: getM3Elevation(isDark)[1],
  };
});

export default HeaderContainer;
